import React from "react"
import Link from "gatsby-link"
import style from "../BlockList/index.module.css"
import shampoo from "../../assets/shampoo.svg"
import tomaat from "../../assets/tomaat.svg"
import spiegel from "../../assets/spiegel.svg"

export default class DilemmaList extends React.Component {
  render() {
    var items = this.props.items;
    var images = {
      "spiegel" : spiegel,
      "tomaat" : tomaat,
      "shampoo" : shampoo,
    };
    return (
      <div className={style.list}>
        {items && items.map((item) => {
          return (
            <article key={item.slug} className={style.item}>
              <Link to={item.slug ? "/boek/" + item.slug : "#"}>
                {item.type &&
                  <img className={style.image} src={images[item.type]} width="200" height="200" />
                }
                {item.title &&
                  <h1 className={style.title}>{item.title}</h1>
                }
              </Link>
              {item.slug &&
                <Link className={style.link} to={`/boek/${item.slug}`}>Lees meer</Link>
              }
            </article>
          )
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DilemmaList/index.js